const defaultProps = require('./default-props');
import {
  COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES
} from 'shared/constants';

const slots = [
  {
    slotId: 'menu-bar',
    label: 'Menu bar'
  },
  {
    slotId: 'content',
    label: 'Main Content Secion'
  },
  {
    slotId: 'footer',
    label: 'Footer area'
  }
];

const templateSettings = [
  {
    type: 'BOOLEAN',
    key: 'subnav_padding',
    label: 'Leave Padding at the Bottom for Sticky SubNav'
  },
  {
    type: 'STRING',
    key: 'background_image',
    label: 'Background Image'
  },
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    type: 'BOOLEAN',
    key: 'overlapping_menubar',
    label: 'MenuBar should overlap the main content'
  },
];

export default {
  id: 'Homepage',
  name: 'Homepage',
  creator: 'Cooper Maruyama',
  updatedBy: 'Phily Austria',
  createdAt: 1497608254954,
  updatedAt: 1497608254954,
  slots,
  templateSettings,
  defaultProps,
  color_theme: 'LIGHT',
};
